import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import {
  PasswordField,
  SButton,
  SContainer,
  SError,
  SFormCheck,
  SFormControl,
  SParagraph,
  STitle,
} from "../../components/BasicComponents";
import AppNavbar from "../../components/Navbars/AppNavbar";
import { AuthContext } from "../../context/AuthContext";
import Loading from "../../components/Loading/Loading";
import { te } from "../../utils/errorsTranslation";

const LoginPage = (props) => {
  const { t } = useTranslation("", { keyPrefix: "auth.login" });

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const { loginUser, loading, error, resetError } = useContext(AuthContext);
  const history = useHistory();

  useEffect(() => {
    return () => resetError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickLogin = (e) => {
    e.preventDefault();
    loginUser({
      email: email,
      password: password,
      rememberMe: true,
    }).then((user) => {
      if (user) {
        const from = props.location?.state?.from;
        if (from) {
          history.push(from);
        } else {
          //Get the section used last time from the localstorage
          const lastAccess = localStorage.getItem("lastAccess");
          history.push(lastAccess || "/student");
        }
      }
    });
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <SContainer dark="true" fluid fill="true" className="d-flex flex-column">
          <Row>
            <AppNavbar dark="true" />
          </Row>

          <Container className="m-auto">
            <Col xl={4} lg={5} md={8} sm={10} className="d-flex flex-column flex-grow-1 justify-content-center">
              <STitle className="fs-1 fw-bolder mb-4 p-2">{t("title")}</STitle>
              <Form className="p-2" onSubmit={onClickLogin}>
                <Form.Group className="p-2">
                  <SFormControl
                    required
                    type="email"
                    placeholder={t("email")}
                    className="my-3 fs-5"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <PasswordField required onChange={(e) => setPassword(e.target.value)} />
                  <SFormCheck
                    type="checkbox"
                    className="my-4"
                    label={t("remember_me")}
                    onChange={() => setRememberMe(!rememberMe)}
                  />
                  <SButton type="submit" dark="true" className="mt-4 w-100 fs-5">
                    {t("login")}
                  </SButton>
                  {error && <SError className="mt-3">{te(error.message)}</SError>}
                  <SParagraph className="w-100 text-center mt-1 mb-0">
                    {t("no_account")} <Link to="/register">{t("sign_up")}</Link>
                  </SParagraph>
                  <SParagraph className="w-100 text-center">
                    <Link to="/forgot-password">{t("forgot_password")}</Link>
                  </SParagraph>
                </Form.Group>
              </Form>
            </Col>
          </Container>
        </SContainer>
      )}
    </>
  );
};

export default LoginPage;
